<i18n src="@/common/i18n/i18n-locales.json"></i18n>
<i18n>
{
  "en": {
    "done": "Done",
    "orderReceived": "Order Received!",
    "seeStaffToCompleteCheckout": "See staff to complete checkout with the following QR code",
    "completeCheckoutAtCashierWithTheFollowingQRCode": "Complete checkout at cashier with the following QR code",
    "completeCheckoutAtCashierBeforePickingOrder": "Complete checkout at cashier with the following QR code before picking up your order",
    "seeStaffToCompleteCheckoutBeforePickingUpOrder": "See staff to complete checkout with the following QR code before picking up your order",
    "paymentMethod": "Payment method",
    "orderId": "Order ID:",
    "tableNumber": "Table number:",
    "pickUpTime": "Pick up time:",
    "taxId": "Tax ID:",
    "invoiceTitle": "Company Name:",
    "cancelOrder": "Cancel order",
    "updateOrder": "Update order",
    "payWithLINEPay": "Pay with LINE Pay",
    "specialRequests": "- Special requests:",
    "serviceCharge": "Service charge {serviceCharge}%",
    "discount": "Discount {discount}% off",
    "price": "$ {price}",
    "total": "Total:",
    "notPaidYet": "Please checkout before completing your order.",
    "removeFailed": "Your order has already paid. Remove failed.",
    "success": "Order placed"
  },
  "zh-tw": {
    "done": "完成",
    "orderReceived": "下單成功!",
    "seeStaffToCompleteCheckout": "請憑此 QR code 洽服務人員付款",
    "completeCheckoutAtCashierWithTheFollowingQRCode": "請憑此 QR code 至付款機掃描付款",
    "completeCheckoutAtCashierBeforePickingOrder": "請在取餐前憑此 QR code 至付款機掃描付款",
    "seeStaffToCompleteCheckoutBeforePickingUpOrder": "請在取餐前憑此 QR code 洽服務人員付款",
    "paymentMethod": "付款方式",
    "orderId": "訂單代號:",
    "tableNumber": "桌號:",
    "pickUpTime": "取餐時間:",
    "taxId": "統一編號:",
    "invoiceTitle": "收據抬頭:",
    "cancelOrder": "取消訂單",
    "updateOrder": "修改訂單",
    "payWithLINEPay": "LINE Pay 付款",
    "specialRequests": "- 備註:",
    "serviceCharge": "服務費 {serviceCharge}%",
    "discount": "優惠折扣 {discount}%",
    "price": "{price} 元",
    "total": "總計:",
    "notPaidYet": "尚未付款，請先至付款區完成付款手續",
    "removeFailed": "訂單已付款，刪除失敗。若要檢視訂單請至點餐紀錄頁面",
    "success": "點餐成功"
  }
}
</i18n>

<template>
  <f7-page>
    <f7-navbar back-link="back">
      <f7-nav-title>{{ $t(`pageTitle.payment`) }}</f7-nav-title>
      <f7-nav-right>
        <f7-link @click="redirctToIndex">{{ $t(`done`) }}</f7-link>
      </f7-nav-right>
    </f7-navbar>

    <div style="display: flex; align-items: center; justify-content: center; flex-direction:column; margin: 0px 0px 30px; font-size: 18px; background-color: white;">
      <f7-block style="text-align: center;">
        <div>{{ $t(`orderReceived`) }}</div>
        <div v-if="!useCashier">{{ $t(`seeStaffToCompleteCheckout`) }}</div>
        <template v-else-if="diningPreference === diningPreferenceType.forHere || diningPreference === diningPreferenceType.takeAway">
          <div v-if="paymentMethod === paymentMethodType.cash">{{ $t(`seeStaffToCompleteCheckout`) }}</div>
          <div v-else>{{ $t(`completeCheckoutAtCashierWithTheFollowingQRCode`) }}</div>
        </template>
        <template v-else>
          <div v-if="paymentMethod === paymentMethodType.cash">{{ $t(`seeStaffToCompleteCheckoutBeforePickingUpOrder`) }}</div>
          <div v-else>{{ $t(`completeCheckoutAtCashierBeforePickingOrder`) }}</div>
        </template>
        <div v-if="paymentMethod">{{ $t(`paymentMethod`) }}: {{ $t(`paymentMethodType.${paymentMethod}`) }}</div>
      </f7-block>
      <qr-code v-if="publicId" :text="publicId" :size="qrCodeWidth" level="H" />
      <f7-block style="text-align: center; width: 100%;">
        <div style="font-weight: bold; font-size: 22px; color: #FF0000;">{{ $t(`orderId`) }} {{ nickname }}</div>
        <div>
          <span>{{ $t(`diningPreferenceType.${diningPreference}`) }}</span>
          <div v-if="diningPreference === diningPreferenceType.forHere">{{ $t(`tableNumber`) }} {{ tableNumber }}</div>
          <div v-else-if="diningPreference === diningPreferenceType.preOrder">{{ $t(`pickUpTime`) }} {{ pickupTime | moment("MM/DD HH:mm") }}</div>
        </div>
        <div v-if="!(useCashier && useReceipt && receiptCarrier !== receiptCarrierType.paper) && taxId">{{ $t(`taxId`) }} {{ taxId }}</div>
        <div v-if="!useReceipt && invoiceTitle">{{ $t(`invoiceTitle`) }} {{ invoiceTitle }}</div>
      </f7-block>
      <f7-segmented v-if="payFirst" style="width: 90%; max-width: 300px; margin: 0px 0px 30px;">
        <f7-button raised fill style="background-color: #DD3333; margin: 0px 5px;" @click="deleteOrderOnClick">{{ $t(`cancelOrder`) }}</f7-button>
        <f7-button raised fill back style="background-color: #365899; margin: 0px 5px;">{{ $t(`updateOrder`) }}</f7-button>
      </f7-segmented>
      <f7-segmented v-else-if="paymentMethod === paymentMethodType.linePayOnline" style="width: 90%; max-width: 300px; margin: 0px 0px 30px;">
        <f7-button raised fill style="background-color: #4CAF50; margin: 0px 5px;" @click="sendLinePayInfo">{{ $t(`payWithLINEPay`) }}</f7-button>
      </f7-segmented>

      <div style="width: 100%; padding: 0px 40px 30px; color: #000000; box-sizing: border-box;">
        <template v-for="(reducedItemObj, index) in selectedItems">
          <div :key="`qr-code-${index}`">
            <div>
              <span>{{ reducedItemObj.item.title }} (${{ reducedItemObj.item.price }}) x {{ reducedItemObj.amount }}</span>
              <span style="float: right;">{{ $t(`price`, { price: reducedItemObj.item.totalPrice * reducedItemObj.amount }) }}</span>
            </div>
            <div v-for="(detail, index) in itemPriceDetails(reducedItemObj.item)" :key="`payment-item-details-${index}`" style="font-size: 12px; color: #212121;">
              - {{ detail }}
            </div>
            <div v-if="reducedItemObj.item.stateObj.specialRequests" style="font-size: 12px; overflow-wrap: break-word;">
              {{ $t(`specialRequests`) }} {{ reducedItemObj.item.stateObj.specialRequests }}
            </div>
            <br>
          </div>
        </template>
        <div v-if="serviceCharge !== 0">
          <span>{{ $t(`serviceCharge`, { serviceCharge }) }}</span>
          <span style="float: right;">{{ $t(`price`, { price: Math.round(parseFloat((subtotal * (serviceCharge / 100)).toFixed(2))) }) }}</span>
        </div>
        <div v-if="paymentMethodDiscount > 0" style="display: flex; margin-top: 10px">
          <span>{{ $t(`discount`, { discount: paymentMethodDiscount }) }}</span>
          <span style="margin-left: auto">-{{ $t(`price`, { price: discountAmount }) }}</span>
        </div>
        <hr>
        <div>
          <span>{{ $t(`total`) }}</span>
          <span style="float: right;">{{ $t(`price`, { price: discountTotalPrice }) }}</span>
        </div>
      </div>
    </div>
  </f7-page>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex'
import QrCode from '@/common/components/QrCode'
import { storeClient } from '@/service/apiClients'

export default {
  dependencies: [
    'orderClient',
    'CartElementBuilder',
    'paymentMethodType',
    'diningPreferenceType',
    'receiptCarrierType'
  ],
  data () {
    return {
      windowWidth: 0,
      windowHeight: 0,
      time: null
    }
  },
  computed: {
    ...mapState([
      'publicId',
      'nickname',
      'diningPreference',
      'paymentMethod',
      'receiptCarrier',
      'taxId',
      'invoiceTitle',
      'tableNumber',
      'pickupTime',
      'menuUrl',
      'paymentMethodDiscount'
    ]),
    ...mapGetters([
      'storeId',
      'payFirst',
      'fullStoreName',
      'serviceCharge',
      'useReceipt',
      'useCashier',
      'currentMenu'
    ]),
    ...mapGetters('itemModule', [
      'allItemObjs',
      'subtotal',
      'totalPrice',
      'discountTotalPrice',
      'discountAmount'
    ]),
    qrCodeWidth () {
      // TODO 這邊還要經過實際測試才知道最大可以多大，目的是不要讓 qrcode 超過 scanner
      return Math.min(300, this.windowWidth * 0.5)
    },
    selectedItems () {
      return this.allItemObjs.map(obj =>
        this.CartElementBuilder.buildItem(obj, this.currentMenu)
      ).reduce((items, item) => {
        const target = items.find(i => i.item.equalsToItem(item))
        if (target === undefined) {
          return items.concat([{
            amount: 1,
            item: item
          }])
        }
        target.amount = target.amount ? target.amount + 1 : 1
        return items
      }, [])
    }
  },
  mounted () {
    this.$nextTick(function () {
      window.addEventListener('resize', this.getWindowWidth)
      window.addEventListener('resize', this.getWindowHeight)

      // Init
      this.getWindowWidth()
      this.getWindowHeight()
    })
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.getWindowWidth)
    window.removeEventListener('resize', this.getWindowHeight)
  },
  methods: {
    getWindowWidth () {
      this.windowWidth = document.documentElement.clientWidth
    },
    getWindowHeight () {
      this.windowHeight = document.documentElement.clientHeight
    },
    itemPriceDetails (item) {
      return item.questions
        ? item.allLevelQuestions.filter(q =>
          q.totalPrice !== 0 || q.alwaysDisplay || !q.isValueDefault
        ).map(q =>
          q.valueString +
          (q.currentLevelPrice === 0 ? '' : ' ($' + q.currentLevelPrice + ')'))
        : []
    },
    async getEstimationTime () {
      const response = await this.orderClient.getEstimationTime(this.stateVersionCode, this.cart.items)
      this.time = response.data.time
    },
    async redirctToIndex () {
      if (this.diningPreference === this.diningPreferenceType.preOrder) {
        this.resetBucket({ itemBucket: 'cart' })
        this.resetOrderParams()
        this.$f7router.back(this.menuUrl, { force: true })
        return
      }
      const { data: result } = await storeClient.get(`stores/${this.storeId}/orders/${this.publicId}/checkPaymentStatus`)
      if (result.paidAt || !this.payFirst) {
        this.$f7.notification.create({
          title: this.fullStoreName,
          text: this.$t(`success`),
          closeOnClick: true,
          closeButton: true,
          closeTimeout: 3000
        }).open()
        this.resetBucket({ itemBucket: 'cart' })
        this.resetOrderParams()
        this.$f7router.back(this.menuUrl, { force: true })
      } else {
        this.$f7.dialog.alert(this.$t(`notPaidYet`), this.fullStoreName)
      }
    },
    async sendLinePayInfo () {
      const result = await storeClient.get(`/stores/${this.storeId}/orders/${this.publicId}/payment/${this.paymentMethod}/info`)
      window.replaceLocation(result.data.paymentUrl.web)
    },
    async deleteOrderOnClick () {
      try {
        await this.deleteOrder(this.publicId)
        this.resetBucket({ itemBucket: 'cart' })
        this.resetOrderParams()
        this.$f7router.back(this.menuUrl, { force: true })
      } catch (e) {
        this.$f7.notification.create({
          title: this.fullStoreName,
          text: this.$t(`removeFailed`),
          closeOnClick: true,
          closeButton: true,
          closeTimeout: 5000
        }).open()
        this.resetBucket({ itemBucket: 'cart' })
        this.resetOrderParams()
        this.$f7router.back(this.menuUrl, { force: true })
      }
    },
    ...mapActions([
      'deleteOrder',
      'resetOrderParams'
    ]),
    ...mapActions('itemModule', ['resetBucket'])
  },
  components: {
    QrCode
  }
}
</script>
